import React, { useState, useEffect } from 'react';
import {
    Box, TextField, Button, IconButton, Modal, Typography, Paper,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    MenuItem, Select, FormControl, InputLabel, CircularProgress, Grid, Container
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useLocation } from 'react-router-dom';

import customerService from '../services/customerService';
import { countryService } from '../services/countryService';
import { regionService } from '../services/regionService';
import { provinceService } from '../services/provinceService';
import { communeService } from '../services/communeService';
import { BranchService } from '../services/branchService';

const CustomersPage = () => {
    // Estado inicial del cliente.
    const [customer, setCustomer] = useState({    
        IdCountry: '',
        IdDistrito: '',
        IdBranch: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        SecondLastName: '',
        Identifier: '',
        Email: '',
        Telephone: '',
        Address: '',
        Observations: '',
        IdStatus: '', 
    });

 

    const location = useLocation();
    const customerData = location.state;


    // Estados para manejar los datos del formulario.
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [regiones, setRegiones] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState('');
    const [provincias, setProvincias] = useState([]);
    const [selectedProvincia, setSelectedProvincia] = useState('');
    const [comunas, setComunas] = useState([]);
    const [selectedComuna, setSelectedComuna] = useState('');
    const [sucursales , setSucursal]= useState([]);
    const [selectedSucursal,setSelectedSucursal]= useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

 

    // Cargar países y regiones al montar el componente.
    useEffect(() => {
        fetchCountry();
        fetchRegion();
        fecthSucursales();
    }, []);



    useEffect(() => {
        if (selectedRegion)
            fetchProvincias(selectedRegion);
    }, [selectedRegion]);

    useEffect(() => {
        if (selectedProvincia)
            fetchComunas(selectedProvincia);
    }, [selectedProvincia]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setCustomer(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleCountryChange = (event) => {
        const countryId = event.target.value;        
        setSelectedCountry(countryId);
    };

    const handleSucursalChange = (event)=>{
       const idBranch = event.target.value;  
        setSelectedSucursal(idBranch);
    };


    const handleRegionChange = (event) => {
        const idRegion = event.target.value;
        setSelectedRegion(idRegion);
        setSelectedProvincia(''); // Reiniciar provincia seleccionada
        setSelectedComuna(''); // Reiniciar comuna seleccionada
        setComunas([]); // Limpiar comunas
    };

    const handleProvinciaChange = (event) => {
        const idProvidence = event.target.value;
        setSelectedProvincia(idProvidence);
        setSelectedComuna('');
    };

    const handleComunaChange = (event) => {
        const comunaId = event.target.value;
        setSelectedComuna(comunaId);
    };


    const fetchCountry = async () => {
        try {
            setLoading(true);
            const data = await countryService.getAllCountry();
            setCountries(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar los roles');
            setLoading(false);
        }
    };

    const fetchRegion = async () => {
        try {
            setLoading(true);
            const data = await regionService.getAllRegion();
            setRegiones(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar los roles');
            setLoading(false);
        }
    };

    const fetchProvincias = async (idRegion) => {
        try {
            setLoading(true);
            const data = await provinceService.getProvincesByRegion(idRegion);

            setProvincias(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las provincias');
            setLoading(false);
        }
    };
    const fetchComunas = async (idProvidence) => {
        try {
            setLoading(true);
            const data = await communeService.getCommunesByProvince(idProvidence);
            setComunas(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las comunas');
            setLoading(false);
        }
    };

    const fecthSucursales = async ()=>{
        try {
            setLoading(true);
            const data = await BranchService.getAllBrach();
            setSucursal(data);
            setLoading(false);
        } catch (err) {
            setError('Error al cargar las comunas');
            setLoading(false);
        }
    };


/*     const handleSubmit = async (e) => {
        e.preventDefault();
        if (!customer.Identifier || !customer.FirstName || !customer.LastName || !customer.Email) {
            alert('Please fill in all required fields.');
            return;
        }
        try {
            await customerService.createCustomer(customer);
            alert('Customer created successfully');
        } catch (error) {
            console.error('Error creating customer', error);
            alert('Error creating customer');
        }
    }; */
    

    return (
        <Container maxWidth="lg">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography variant="h5" gutterBottom>
                    CAUSAS CIVILES
                </Typography>
        {/*         <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}> */}
                <Box component="form" noValidate autoComplete="off" >
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="identifier"
                                label="Rut"
                                name="Identifier"
                                value={customerData?.rut || ''}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="identifier"
                                label="Rol"
                                name="Identifier"
                                value={customerData?.rol || ''}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="firstName"
                                label="Tribunal"
                                name="FirstName"
                                value={customerData?.tribunal|| ''}
                                onChange={handleChange}
                            />

                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="firstName"
                                label="Nombre Causa - Caratula"
                                name="FirstName"
                                value={customerData?.nombreCausa || ''}
                                onChange={handleChange}
                            />

                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="lastName"
                                label="Fecha de Ingreso"
                                name="LastName"
                                value={customerData?.fIng || ''}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="email"
                                label="Etapa"
                                name="Email"
                                value={customerData?.etapa || ''}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                required
                                id="telephone"
                                label="Proc"
                                name="Telephone"
                                value={customerData?.proc || ''}
                                onChange={handleChange}
                            />
                        </Grid>


        
                    </Grid>
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'right' }}>
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            type="submit"
                            size="large"
                        >
                          Continuar
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default CustomersPage;